export default "__VITE_ASSET__DG01Gn38__"